import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
// @ts-ignore
import { Tooltip } from '@netbasequid/core'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
import { AUTO_ATTR_KEY, AutomationId } from 'utils/automationUtil'
import { StreamData } from 'types/streamData'
import { DateStyle } from '../index.css'

const StyledDateLink = styled.a<{ disabled?: boolean }>`
  overflow: hidden;
  -webkit-box-orient: vertical;
  text-decoration: none;
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
`

const StyledDateInLink = styled.div.attrs({
  [AUTO_ATTR_KEY]: AutomationId.soundbiteDefaultFrame.date
})`
  ${DateStyle}
  white-space: nowrap;
  min-width: 20px;
`

type LinkedDateProps = {
  streamData: StreamData
}

const LinkedDate = ({ streamData }: LinkedDateProps) => {
  const { t } = useTranslation()
  const theme = useDisplayTheme() as Theme

  const { domain, fullDateTime, timestamp, url } = streamData

  return (
    <Tooltip mode={theme} enabled content={!domain ? t('soundbiteNoUrl') : fullDateTime}>
      <StyledDateLink
        href={!domain ? undefined : url}
        target="_blank"
        rel="noreferrer"
        disabled={!domain}
        onClick={(event) => {
          event.stopPropagation()
        }}>
        <StyledDateInLink mode={theme}>{timestamp!}</StyledDateInLink>{' '}
      </StyledDateLink>
    </Tooltip>
  )
}

export default LinkedDate
